'use es6';

import { forwardRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as MenuTreeActions from 'simple-menus-core/actions/MenuTree';
import { getMenuTreeNode } from 'simple-menus-core/selectors/menuTree';
import { DropPositions } from 'simple-menus-lib/constants/dragAndDrop';
import { jsx as _jsx } from "react/jsx-runtime";
function makeMapStateToProps() {
  return function mapStateToProps(state, props) {
    return {
      treeNode: getMenuTreeNode(state, props)
    };
  };
}
const mapDispatchToProps = {
  addNode: MenuTreeActions.addNode,
  moveNode: MenuTreeActions.moveNode,
  addChildNode: MenuTreeActions.addChildNode
};
const HOC = Component => {
  const WithConnectedMenuNodeDivider = /*#__PURE__*/forwardRef((props, ref) => {
    const {
      addNode: addNodeAction,
      addChildNode,
      moveNode: moveNodeAction,
      parentId,
      id,
      position = DropPositions.BOTTOM,
      treeNode,
      menuId,
      isCollapsed,
      depth,
      isParentDragging,
      hasChildren,
      isLastChild,
      hasSibling,
      depthToNextSibling,
      hierarchy = [],
      readOnly
    } = props;
    const addNode = useCallback(type => {
      if (treeNode.children.length && position === DropPositions.BOTTOM && !isCollapsed) {
        addChildNode(id, menuId, {
          type
        });
      } else {
        addNodeAction(menuId, parentId, id, {
          type
        }, position);
      }
    }, [addNodeAction, addChildNode, parentId, id, position, treeNode, menuId, isCollapsed]);
    const moveNode = useCallback(node => {
      const {
        id: nodeId
      } = node;
      const dropPosition = treeNode.children.length && position === DropPositions.BOTTOM && !isCollapsed ? DropPositions.MIDDLE : position;
      moveNodeAction(nodeId, id, parentId, dropPosition, menuId);
    }, [moveNodeAction, id, parentId, position, treeNode, menuId, isCollapsed]);
    if (!treeNode) return null;
    return /*#__PURE__*/_jsx(Component, {
      id: id,
      depth: depth,
      addNode: addNode,
      moveNode: moveNode,
      isParentDragging: isParentDragging,
      hasChildren: hasChildren,
      isLastChild: isLastChild,
      hasSibling: hasSibling,
      depthToNextSibling: depthToNextSibling,
      hierarchy: hierarchy,
      menuId: menuId,
      moveNodeAction: moveNodeAction,
      readOnly: readOnly,
      ref: ref
    });
  });
  WithConnectedMenuNodeDivider.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    menuId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    depth: PropTypes.number.isRequired,
    position: PropTypes.oneOf([DropPositions.TOP, DropPositions.BOTTOM]),
    addNode: PropTypes.func.isRequired,
    moveNode: PropTypes.func.isRequired,
    treeNode: PropTypes.object,
    addChildNode: PropTypes.func.isRequired,
    isParentDragging: PropTypes.bool,
    isLastChild: PropTypes.bool,
    hasChildren: PropTypes.bool,
    depthToNextSibling: PropTypes.number,
    hasSibling: PropTypes.bool,
    hierarchy: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
    isCollapsed: PropTypes.bool,
    readOnly: PropTypes.bool
  };
  WithConnectedMenuNodeDivider.displayName = `WithConnectedMenuNodeDivider(${Component.displayName || Component.name || 'Component'})`;
  return connect(makeMapStateToProps, mapDispatchToProps)(WithConnectedMenuNodeDivider);
};
export default function withConnectedMenuNodeDivider() {
  return HOC;
}